const navBarTranslations = {
  overview: {
    title: "ملخص",
    links: {
      home: "الصفحة الرئيسية",
      meals: "برنامج التغذية",
      supplements: "المكملات الغذائية",
      workout: "البرنامج التدريبي",
      explanation: "الشرح",
    },
  },
  support: {
    title: "المساعدة",
    links: {
      requestSupport: "طلب لمساعدة",
      bugReport: "الابلاغ عن الأخطاء والمشكلات",
      inquiries: "استفسارات",
    },
  },
  navBarDocs: {
    description: "يعجبك ما تري؟ تفضل بزيارتنا",
    actionButton: "اظهار المزيد",
  },
};

export default navBarTranslations;
